import { IncidentSummarySchema } from "../incidentSummary";
import { CommentsContainer, MarkdownContainer, TextContainer } from "../incidentSummary.styled";
import Markdown from 'markdown-to-jsx'
import IncidentComments from "../incidentComments";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { Paper } from "@mui/material";
import { UserClaims } from "core/contexts/auth/auth";

export interface MalwareUploadTableSummaryProps {
    incidentSummary: IncidentSummarySchema | undefined;
    user: UserClaims | null;
}

export const MalwareUploadTableSummary = ({
    incidentSummary,
    user
  }: MalwareUploadTableSummaryProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // If incidentSummary is undefined, return a fallback or null to avoid rendering errors
    if (!incidentSummary) {
        return <p>No incident summary available.</p>;  // Or any fallback UI
    }

    return (
        <>
            <span>
                <span className="d-flex flex-row align-content-center mt-3">
                    <p>Event:</p>
                    <strong className="m-0 ps-2">{incidentSummary.event}</strong>
                </span>
            </span>

            <MarkdownContainer>
                <Markdown className="mb-3">
                    {incidentSummary.code_analysis || ""}
                </Markdown>
            </MarkdownContainer>

            <CommentsContainer>
                <IncidentComments 
                    t={t} theme={theme} 
                    initialComments={incidentSummary.comments || []} 
                    incidentId={incidentSummary.id || ""} 
                    user={user} 
                />
            </CommentsContainer>
            
            <TextContainer container spacing={2} className="d-flex flex-column">
                <strong className="mb-3" style={{fontSize: theme.font.large}}>{t("INCIDENTS_PAGE.AI_DISCLAMER_TITLE")}:</strong>
                <p className="word-break"><strong>{t("INCIDENTS_PAGE.PLEASE_NOTE")}: </strong> 
                The information provided here has been generated by AI and, as such, may contain inaccuracies or &#39;hallucinations&#39;. We advise users to verify the accuracy of the information before relying on it for any critical decisions or actions.
                </p>
            </TextContainer>
        </>
    );
};
